import PropTypes from 'prop-types';
import React from 'react';

import Button from 'common/components/Button';
import noop from 'common/tools/noop';
import trans from 'common/tools/translations/trans';

const defaultButtonText = trans('userspace.my-community.user-card.follow');

const FollowButton = ({
  className,
  size,
  onClick,
  disabled,
  theme,
  type,
  children
}) => (
  <Button
    className={className}
    theme={theme}
    type={type}
    size={size}
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </Button>
);

FollowButton.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  theme: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node
};

FollowButton.defaultProps = {
  size: 'sm',
  className: undefined,
  disabled: false,
  onClick: noop,
  theme: 'inverse',
  type: 'full',
  children: defaultButtonText
};

export default FollowButton;
